import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams, useSearchParams } from "react-router-dom";
import polygonLogo from "../assets/polygon-logo.png";
import analysisIcon from "../assets/score-analysis-icon.png";
import likeIcon from "../assets/like-icon.png";
import unlikeicon from "../assets/unlike-icon.png";
import trustScoreImage from "../assets/trust-score-img.png";
import apis from "../services";
import { toast } from "react-toastify";
import { FaLock } from "react-icons/fa";
import { IoIosArrowBack } from "react-icons/io";

const data = [
  { feature: "Total Supply", id: "total_supply" },
  { feature: "Lp Holders", id: "holder_count" },
  { feature: "Transfer pausable", id: "transfer_pausable" },
  { feature: "Trading Cooldown", id: "trading_cooldown" },
  { feature: "Hidden Owner", id: "hidden_owner" },
  { feature: "Token Percentage of Owner", id: "owner_percent" },
  { feature: "Whitelist", id: "is_whitelisted" },
  { feature: "Blacklist", id: "is_blacklisted" }, //done
  { feature: "Token Holder Number", id: "holder_count" },
  { feature: "Honeypot", id: "is_honeypot" },
  { feature: "Honeypot with same creator", id: "honeypot_with_same_creator" },
  { feature: "Is in DEX", id: "is_in_dex" },
  { feature: "Open Source", id: "is_open_source" },
];

const rightSideData = [
  { feature: "Sell Tax", id: "sell_tax" },
  { feature: "Buy Tax", id: "buy_tax" },
  { feature: "Token Percentage of Creator", id: "creator_percent" },
  { feature: "Proxy Contract", id: "is_proxy" },
  { feature: "Owner Balance", id: "owner_balance" },
  { feature: "Take Back Ownership", id: "can_take_back_ownership" },
  { feature: "Modifiable Tax", id: "slippage_modifiable" },
  { feature: "With External Call", id: "external_call" },
  { feature: "Cannot Sell All", id: "cannot_sell_all" },
  { feature: "LP Token Holder Number", id: "holder_count" },
  {
    feature: "Assigned Address' Slippage is Modifiable",
    id: "personal_slippage_modifiable",
  },
  { feature: "Anti Whale", id: "is_anti_whale" },
  { feature: "Mint Function", id: "is_mintable" },
  { feature: "Owner Can Change Balance", id: "owner_change_balance" },
  { feature: "Cannot Be Bought", id: "cannot_buy" },
  { feature: "Modifiable Anti Whale", id: "anti_whale_modifiable" },
];

const NewDetail = () => {
  const { tokenaddress } = useParams();
  const [searchParams] = useSearchParams()
  const chainName = searchParams.get("chainName")
  const checkScam = searchParams.get("checkScam")
  const [tokenData, setTokenData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleCheckScam = async () => {
    setLoading(true);
    try {

      const tokenAddressLocalStorage = JSON.parse(localStorage.getItem("token-address"))
      const tokenFromLocalStorage = JSON.parse(localStorage.getItem("token-data"))

      if(tokenAddressLocalStorage == tokenaddress) {
        setTokenData(tokenFromLocalStorage)
        setLoading(false)
        return;
      } else {
        setError(true);
      }

      const response = await apis.getDetails(tokenaddress);

      if (response.status === 200) {
        setTokenData(response.data);
      } else {
        toast.error("Invalid response from API");
        setError(true);
      }
    } catch (err) {
      if (err.response?.status === 404) {
        toast.error('Record not found, will get back shortly');
      } else {
        toast.error(err.response?.data?.message || 'Something went wrong.');
      }
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchCards = async () => {
    setLoading(true);
    setError(null);
    try {

      const response = await apis.getTokenById(tokenaddress, chainName);

      if (response) {
        setTokenData(response)
      } else {
        setTokenData({});
      }
    } catch (err) {
      toast.error(err.message)
      setError(err.message || 'Failed to fetch data');
      console.error('Error fetching cards:', err.message); 
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(checkScam == "true") {
      handleCheckScam();
    } else {
      fetchCards();
    }
  }, [checkScam, tokenaddress]);

  return (
    <div className="main-invest-details">
      <div className="header-container">
        <div className="header-content">
          <h1 className="header-title">Lookna</h1>
          <h2 className="header-subtitle">
            FIND YOUR{" "}
            <span className="color-sp">
              IDEAL <br /> INVESTMENT
            </span>{" "}
            VAULT
          </h2>
          <p className="header-description">
            Discover a range of investment options tailored to your needs, from{" "}
            <br /> automated solutions to customizable strategies
          </p>
        </div>
        <div className="details-borders"></div>
      </div>

      {loading ? (
        <div className="record">Loading...</div>
      ) : error ? (
        <div className="record">No worries, we're updating the details and they’ll be available for you shortly!.</div>
      ) : (
        <>
          {/* <div className="back-button">
            <Link to={"/check-scam"}>
              <button type="submit">
                <IoIosArrowBack /> Back
              </button>
            </Link>
          </div> */}

          <div className="invest-details">
            <div className="top">
              <div className="left">
                <div className="heading-left">
                  <img src={polygonLogo} alt="token logo" />
                  {/* <h2>{tokenData.tokenName} ({tokenData.tokenSymbol})</h2> */}
                  <h2>{tokenData?.tokenName || '-'}</h2>
                </div>

                <div className="price">
                  <p>Price:</p>
                  <p>{tokenData?.price || '-'}</p>
                </div>

                <div className="token-address">
                  <p>Token Address:</p>
                  <p>{tokenaddress}</p>
                  {/* <img src={fileCopyIcon} alt="copy file icon" /> */}
                </div>

                {/* {Number(tokenData?.isLookna || '-') !== 0 && (
                  <div className="peer-address">
                    <p>Pair Address:</p>
                    <p>{tokenData?.pairAddress || '-'}</p>
              
                  </div>
                )} */}
                <div className="peer-address">
  <p>Pair Address:</p>
  <p>{tokenData?.pairAddress || '-'}</p>
</div>

                {/* Add more dynamic token details as needed */}
                <div className="single-vault-detail">
                  <div>
                    {/* <div className="liquidity">
  <p style={{ wordBreak: 'break-word' }}>Address</p>
  <p>{tokenData.tokenDetails.creator_address}</p>
</div> */}
                    <div className="liquidity">
                      <p>Price</p>
                      <p>
                        {tokenData?.price || '-' == "-" ? "" : "$ "}
                        {tokenData.price.length > 30
                          ? tokenData.price.slice(0, 30) +
                            "\n" +
                            tokenData.price.slice(30)
                          : tokenData.price}
                      </p>
                    </div>
                  </div>

                  <div>
                  <div className="liquidity">
  <p>FDV</p>
  <p>
    {tokenData.price === "-" ? "" : "$ "}
    {tokenData.fdv?.length > 10
      ? tokenData.fdv.slice(0, 20) + "\n" + tokenData.fdv.slice(20)
      : tokenData.fdv}
  </p>
</div>
                    {/* {Number(tokenData?.isLookna || '-') !== 0 && (
                      <div className="liquidity">
                        <p>FDV</p>
                        <p>
                          {tokenData.price == "-" ? "" : "$ "}
                          {tokenData.price.length > 10
                            ? tokenData.fdv.slice(0, 20) +
                              "\n" +
                              tokenData.fdv.slice(20)
                            : tokenData.fdv}
                        </p>
                      </div>
                    )} */}

                    {/* {Number(tokenData?.isLookna) !== 0 && (
                      <div className="holders">
                        <p>
                          Liquidity{" "}
                          {Number(
                            tokenData?.tokenDetails?.lp_holders[0]?.is_locked
                          ) !== 0 ? (
                            <FaLock />
                          ) : (
                            ""
                          )}
                        </p>
                        {tokenData.liquidity > 20 ? (
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            ${tokenData.liquidity.toString()}
                          </p>
                        ) : (
                          <p>${tokenData?.liquidity||'-'}</p>
                        )}
                      </div>
                    )} */}
                    <div className="holders">
  <p>
    Liquidity{" "}
    {Number(tokenData?.tokenDetails?.lp_holders[0]?.is_locked) !== 0 ? (
      <FaLock />
    ) : (
      ""
    )}
  </p>
  {tokenData.liquidity > 20 ? (
    <p style={{ whiteSpace: "pre-wrap" }}>
      ${tokenData.liquidity.toString()}
    </p>
  ) : (
    <p>${tokenData?.liquidity || '-'}</p>
  )}
</div>
                  </div>

                  <div>
                    <div className="ageses">
                      <p>Coin Name</p>
                      <p>{tokenData?.tokenName||'-'}</p>
                    </div>

                    <div className="riskses">
                      <p>Price Provider</p>
                      <p>{tokenData?.priceProvider || '-'}</p>
                      </div>
                  </div>
                </div>
                <div className="card-footer-details">
                  <div className="progresss-bar-border">
                    <div className="progress-bar">
                      <div className="progress-fill"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="heading-right">
                  <img src={analysisIcon} alt="score analysis" />
                  <h2>LOOKNA SCORE ANALYSIS</h2>
                </div>
                <div className="score-analysis-bottom">
                  <table>
                    <tr>
                      <td>With Hidden Owner</td>
                      <td>
                        {Number(tokenData.tokenDetails.hidden_owner) == 0
                          ? "No"
                          : "Yes"}
                      </td>
                      <td>
                        <img
                          src={
                            Number(tokenData.tokenDetails.hidden_owner) == 0
                              ? unlikeicon
                              : likeIcon
                          }
                          alt="status icon"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Self-Destruct</td>
                      <td>
                        {Number(tokenData.tokenDetails.selfdestruct) == 0
                          ? "No"
                          : "Yes"}
                      </td>
                      <td>
                        <img
                          src={
                            Number(tokenData.tokenDetails.selfdestruct) == 0
                              ? unlikeicon
                              : likeIcon
                          }
                          alt="status icon"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Honeypot</td>
                      <td>
                        {Number(tokenData.tokenDetails.is_honeypot) == 0
                          ? "No"
                          : "Yes"}
                      </td>
                      <td>
                        <img
                          src={
                            Number(tokenData.tokenDetails.is_honeypot) == 0
                              ? unlikeicon
                              : likeIcon
                          }
                          alt="status icon"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Honeypot with Same Creator</td>
                      <td>
                        {Number(
                          tokenData.tokenDetails.honeypot_with_same_creator
                        ) == 0
                          ? "No"
                          : "Yes"}
                      </td>
                      <td>
                        <img
                          src={
                            Number(
                              tokenData.tokenDetails.honeypot_with_same_creator
                            ) == 0
                              ? unlikeicon
                              : likeIcon
                          }
                          alt="status icon"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Proxy Contract</td>
                      <td>
                        {Number(tokenData.tokenDetails.is_proxy) == 0
                          ? "No"
                          : "Yes"}
                      </td>
                      <td>
                        <img
                          src={
                            Number(tokenData.tokenDetails.is_proxy) == 0
                              ? unlikeicon
                              : likeIcon
                          }
                          alt="status icon"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Cannot Be Bought</td>
                      <td>
                        {Number(tokenData.tokenDetails.cannot_buy) == 0
                          ? "No"
                          : "Yes"}
                      </td>

                      <td>
                        <img
                          src={
                            Number(tokenData.tokenDetails.cannot_buy) == 0
                              ? unlikeicon
                              : likeIcon
                          }
                          alt="status icon"
                        />
                      </td>
                    </tr>

                    <tr className="">
                      <td className="">
                        Total Score
                      </td>
                      <td>
                        <span>{tokenData.totalScore}%</span>
                      </td>
                      <td
                        className="asdasdasdasdasd"
                        style={{
                          color:
                            tokenData.riskLevel?.toLowerCase() === "high risk"
                              ? "red"
                              : tokenData.riskLevel?.toLowerCase() ===
                                "low risk"
                              ? "green"
                              : "red",
                        }}
                      >
                        <span>{tokenData?.riskLevel||'-'}</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="table-container">
            <div className="table">
              <div className="left-column">
                {data.map((item, index) => (
                  <div key={index} className="row" id={item.id}>
                    <div className="row-list-style">
                      <span className="list-style">• </span>
                      <span className="feature">{item.feature}</span>
                    </div>
                    <span className="value">
                      {Number(tokenData.tokenDetails[item.id]) == 0
                        ? "No"
                        : "Yes"}
                      <img
                        src={
                          Number(tokenData.tokenDetails[item.id]) == 0
                            ? unlikeicon
                            : likeIcon
                        }
                        alt="status icon"
                      />
                    </span>
                  </div>
                ))}
              </div>

              <div className="right-column">
                {rightSideData.map((item, index) => (
                  <div key={index} className="row" id={item.id}>
                    <div className="row-list-style">
                      <span className="list-style">• </span>
                      <span className="feature">{item.feature}</span>
                    </div>
                    <span className="value">
                      {Number(tokenData.tokenDetails[item.id]) == 0
                        ? "No"
                        : "Yes"}
                      <img
                        src={
                          Number(tokenData.tokenDetails[item.id]) == 0
                            ? unlikeicon
                            : likeIcon
                        }
                        alt="status icon"
                      />
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NewDetail;
